import md5 from 'js-md5'
// import { sleep } from 'antd-mobile/es/utils/sleep'
import user from '@/stores/user'
import { getBaseUrl } from './baseUrl'

export const REQUEST_AUTH_TOKEN = 'AUTH-TOKEN'
export const REQUEST_AUTH_USERID = 'AUTH-USERID'

const makeToken = (timestamp: number) => {
  const app_key = 'Jupiter#E^~i)5cLtQ$izjQ'
  const app_secret = 'Jupiter#YIewwUP5Df(5*mjBjyxq(sffJshM2S'
  const app_salt = '5kxhKVshKrVxd05MD2!'
  const client_id = 'CMCC'
  const client_type = 'WAP'
  return md5(
    `app_key=${app_key}&app_secret=${app_secret}&auth_timestamp=${timestamp}&client_id=${client_id}&client_type=${client_type}#${app_salt}`,
  )
}

export const getHeader = async () => {
  return user.from === 'CMCC' ? await getHeaderCMCC() : await getHeaderAPP()
}

export const getHeaderCMCC = async () => {
  const timestamp = Date.now()
  const token = makeToken(timestamp)
  // let phoneNumber = sessionStorage.getItem('phoneNumber') || ''
  // if (!phoneNumber) {
  //   await sleep(1000)
  //   phoneNumber = sessionStorage.getItem('phoneNumber') || ''
  // }
  return {
    'AUTH-TIMESTAMP': timestamp,
    'CLIENT-ID': 'CMCC',
    'AUTH-TOKEN': token,
    'AUTH-PRINCIPAL': user.phoneNumber,
    SOURCE: 'WAP',
  }
}

export const getHeaderAPP = async () => {
  return {
    'content-type': 'application/json',
    [REQUEST_AUTH_TOKEN]: user.token || '',
    [REQUEST_AUTH_USERID]: user.uid || '',
    'SERVER-VERSION': '1.0.1',
    SOURCE: 'APP',
  }
}

export const getImage = (url: string) => {
  return `${getBaseUrl()}/presigned/v1/view?objectname=${url}`
}

export const isEmpty = (value: any) => {
  if (value === '') return true //检验空字符串
  if (value === 'null') return true //检验字符串类型的null
  if (value === 'undefined') return true //检验字符串类型的 undefined
  if (!value && value !== 0 && value !== '') return true //检验 undefined 和 null
  if (Array.prototype.isPrototypeOf(value) && value.length === 0) return true //检验空数组
  if (Object.prototype.isPrototypeOf(value) && Object.keys(value).length === 0) return true //检验空对象
  return false
}

export const parseCookie = (): any => {
  const res: any = {}
  const vars = document.cookie.split('; ')

  for (var i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=')
    res[pair[0]] = pair[1]
  }
  return res
}
